import { useTranslation } from 'react-i18next';
import {
    ButtonPrimary,
    ButtonSecondary,
    ButtonTertiaryOnLightM,
    IconIdentifier,
    LoadingStatus,
    WizardNavigationButtons,
} from '@steelbuy/ui-primitive';

export const WizardActionBar = ({
    onNext,
    onBack,
    nextLabel,
    isSubmitDisabled,
    onSaveDraft,
    isLoading = false,
    isSubmitting = false,
    nextButtonType = 'submit',
}: {
    onNext: () => void;
    onBack?: () => void | undefined;
    nextLabel: string;
    isSubmitDisabled: boolean;
    onSaveDraft?: () => void;
    isLoading: boolean;
    isSubmitting?: boolean;
    nextButtonType?: 'submit' | 'button';
}) => {
    const { t } = useTranslation(['translation', 'uiDomain']);

    return (
        <WizardNavigationButtons columns>
            {onSaveDraft ? (
                <ButtonTertiaryOnLightM
                    label={t('application.createRFQ.saveAsDraft')}
                    onClick={onSaveDraft}
                    loadingStatus={isLoading ? LoadingStatus.PENDING : LoadingStatus.IDLE}
                    disabled={isSubmitting}
                />
            ) : (
                <div />
            )}
            <div>
                {onBack && (
                    <ButtonSecondary
                        label={t('uiDomain:common.back')}
                        type="submit"
                        onClick={onBack}
                        disabled={isSubmitting}
                    />
                )}
                <ButtonPrimary
                    type={nextButtonType}
                    label={nextLabel}
                    icon={IconIdentifier.CHEVRON_RIGHT}
                    disabled={isSubmitDisabled}
                    onClick={onNext}
                    loadingStatus={isSubmitting ? LoadingStatus.PENDING : LoadingStatus.IDLE}
                />
            </div>
        </WizardNavigationButtons>
    );
};
